import TransmedReceiving, {
  TransmedReceivingInput,
} from "../../../dtos/transmed/process/receiving";
import Service, {
  ServiceCreator,
  ServiceDeleter,
  ServiceReader,
  ServiceUpdater,
} from "../..";
import TransmedReceivingApi from "../../../api/transmed/receiving";
import TransmedReceivingDetail from "../../../dtos/transmed/process/receivingDetail";
import TransmedReceivingDetailApi from "../../../api/transmed/receivingDetail";

class TransmedReceivingServiceReader extends ServiceReader {
  public async all(): Promise<TransmedReceiving[]> {
    return await new TransmedReceivingApi().get();
  }

  public async incomings(): Promise<TransmedReceivingDetail[]> {
    return await new TransmedReceivingDetailApi().get();
  }
}

class TransmedReceivingServiceCreator extends ServiceCreator {
  public async receiving(
    lc_id: string,
    accomodation_yes: number | null,
    accomodation_no: number | null,
    exchange_start: Date,
    exchange_end: Date,
    whatsapp: string,
    acceptance_message: string,
    payment: boolean
  ): Promise<TransmedReceiving> {
    return await new TransmedReceivingApi().post(
      new TransmedReceivingInput(
        lc_id,
        accomodation_yes,
        accomodation_no,
        exchange_start,
        exchange_end,
        whatsapp,
        acceptance_message,
        payment
      )
    );
  }
}

class TransmedReceivingServiceUpdater extends ServiceUpdater {
  public async receiving(
    id: number,
    lc_id: string,
    accomodation_yes: number | null,
    accomodation_no: number | null,
    exchange_start: Date,
    exchange_end: Date,
    whatsapp: string,
    acceptance_message: string,
    payment: boolean
  ): Promise<TransmedReceiving> {
    return await new TransmedReceivingApi().put(
      `${id}`,
      new TransmedReceivingInput(
        lc_id,
        accomodation_yes,
        accomodation_no,
        exchange_start,
        exchange_end,
        whatsapp,
        acceptance_message,
        payment
      )
    );
  }
}

class TransmedReceivingServiceDeleter extends ServiceDeleter {
  public async coordinator(id: number): Promise<void> {
    return await new TransmedReceivingApi().delete(`${id}`);
  }
}

export default class TransmedReceivingService extends Service {
  public get read(): TransmedReceivingServiceReader {
    return new TransmedReceivingServiceReader();
  }
  public get create(): TransmedReceivingServiceCreator {
    return new TransmedReceivingServiceCreator();
  }
  public get update(): TransmedReceivingServiceUpdater {
    return new TransmedReceivingServiceUpdater();
  }
  public get delete(): TransmedReceivingServiceDeleter {
    return new TransmedReceivingServiceDeleter();
  }
}
